import { render, staticRenderFns } from "./addeditdept.vue?vue&type=template&id=4f1a703c&scoped=true&"
import script from "./addeditdept.vue?vue&type=script&lang=js&"
export * from "./addeditdept.vue?vue&type=script&lang=js&"
import style0 from "./addeditdept.vue?vue&type=style&index=0&id=4f1a703c&lang=less&scoped=true&"
import style1 from "./addeditdept.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1a703c",
  null
  
)

export default component.exports